import { buildPublicShortlistUrl as buildPublicWebShortlistUrl } from '../public-web';

export type RouteParamValue = string | string[] | null | undefined;

const INVALID_SLUG_SENTINELS = new Set(['undefined', 'null']);

export function normalizeRouteParamValue(value: RouteParamValue): string | null {
  const raw = Array.isArray(value) ? value[0] : value;
  if (typeof raw !== 'string') return null;

  const normalized = raw.trim();
  if (!normalized) return null;

  return normalized;
}

export function normalizeShortlistSlug(value: RouteParamValue): string | null {
  const normalized = normalizeRouteParamValue(value);
  if (!normalized) return null;

  const lowered = normalized.toLowerCase();
  if (INVALID_SLUG_SENTINELS.has(lowered)) return null;
  if (normalized.includes('/')) return null;

  return normalized;
}

export type PublicShortlistView = 'start' | 'review' | 'confirm';

export function buildPublicShortlistPath(slugValue: RouteParamValue, view: PublicShortlistView = 'start'): string | null {
  const slug = normalizeShortlistSlug(slugValue);
  if (!slug) return null;

  if (view === 'start') {
    return `/s/${slug}`;
  }

  return `/s/${slug}/${view}`;
}

export function buildPublicShortlistUrl(slugValue: RouteParamValue): string | null {
  const path = buildPublicShortlistPath(slugValue, 'start');
  if (!path) return null;
  return buildPublicWebShortlistUrl(path);
}
